import React, { Component } from 'react';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import ReactGA from 'react-ga';
import { StripeProvider } from 'react-stripe-elements';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';

import './App.css';

import configureStore from './store';

import AppView from './AppView';

const stripePk = window.location.hostname === 'hub.staza.io' ? 'pk_live_1yeraU9HDVYQPInRRxRAFH1s' : 'pk_test_0U16R3nYiIlUXvGNDIPcJgFG';

const history = createHistory();

history.listen((location) => {
  // analyticsService.track(location.pathname)
  console.log('Google GA - logging page change', location.pathname);
  ReactGA.set({ page: location.pathname + location.search });
  ReactGA.pageview(location.pathname + location.search);
});

ReactGA.initialize('UA-106817069-2');

const initialState = {};
const store = configureStore(initialState, history);

// const muiTheme = createMuiTheme({
//   // palette: {
//   //   primary1Color: PRIMARY,
//   //   accent1Color: SECONDARY,
//   // },
//   // appBar: {},
//   // toolbar: {},
//   overrides: {
//     MuiButton: { // Name of the component ⚛️ / style sheet
//       root: { // Name of the rule
//         color: 'white', // Some CSS
//       },
//     },
//   },
// });

// console.log('muiTheme', muiTheme);

class App extends Component {
  render() {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Provider store={store}>
          <StripeProvider apiKey={stripePk}>
            <AppView history={history}/>
          </StripeProvider>
        </Provider>
      </MuiPickersUtilsProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js